import { Component, Injector, OnInit } from '@angular/core';
import { BaseClass } from '../../utility/baseClass';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { ApplicationconfigurationService } from '../../main-layout/applicationconfiguration/applicationconfiguration.service';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
@Component({
  selector: 'app-applicationconfigurationmodal',
  templateUrl: './applicationconfigurationmodal.component.html',
  styleUrls: ['./applicationconfigurationmodal.component.css']
})
export class ApplicationconfigurationmodalComponent extends BaseClass implements OnInit {
  CSRFToken = '';
  description: any;

  form: FormGroup;
  saveTitle = "Add";
  isEdit: boolean = false;
  products = [];
  ConfigurationForm: FormGroup;
  modifyform: FormGroup
  configdetailsList: Array<any> = [];
  filterproductdata: any = {};
  productlist = [];
  descheight: number = 2;

  loginuserid = 0;
  datatypelist = [
    { label: 'Select', value: '' },
    { label: 'Numeric', value: 'Numeric' },
    { label: 'Text', value: 'Text' },
    { label: 'Flag', value: 'Flag Type' }

  ];
  yesnolist = [
    { label: 'Yes', value: 'Y' },
    { label: 'No', value: 'N' }
  ]
  onlyView: boolean = false;
  existingdetails: any
  public validation_message = {
    'mainkey': [
      { type: 'required', message: 'Main Key is required.' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'SPACESTRICTFORINITIALVALIDATION', message: 'Space is not allowed at the beginning' },
    ],

    'subKey': [{ type: 'required', message: 'Sub Key is required' }, { type: 'maxlength', message: 'Maximum length exceeded' }, { type: 'ONLYNUMERIC', message: 'Only Numeric allowed' }],
    'dataType': [{ type: 'required', message: 'Data Type is required' }],
    'title': [
      { type: 'required', message: 'Title is required.' },
      { type: 'SPACESTRICTFORINITIALVALIDATION', message: 'Space is not allowed at the beginning' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ],
    'keyValue': [{ type: 'required', message: 'Key Value is required' }, { type: 'SPACESTRICTFORINITIALVALIDATION', message: 'Space is not allowed at the beginning' }, { type: 'maxlength', message: 'Maximum length exceeded' }],
    'description': [{ type: 'required', message: 'Description is required' },
    { type: 'SPACESTRICTFORINITIALVALIDATION', message: 'Space is not allowed at the beginning' },
    { type: 'maxlength', message: 'Maximum length exceeded' }],
    'pmsEdit': [{ type: 'required', message: 'PMS Edit is required' }],
    'product': [{ type: 'required', message: 'Product is required' }],
    'pmsShow': [{ type: 'required', message: 'PMS Show is required' }],
    'selfShow': [{ type: 'required', message: 'Self Show is required' }],
    'selfEdit': [{ type: 'required', message: 'Self Edit is required' }]
  }

  constructor(public override injector: Injector, private fb: FormBuilder, private appconfigservice: ApplicationconfigurationService, public ref: DynamicDialogRef, private utilityservice: Utilityservice, public config: DynamicDialogConfig,) {

    super(injector);
    const datafromparent = this.config.data;
    this.gettoken();
    if (datafromparent?.title === 'Modify Configuration') {
      this.isEdit = true;
      this.saveTitle = 'Modify';
      this.existingdetails = datafromparent.datas;
      this.description = this.existingdetails.description;
      this.datatypelist = this.datatypelist.filter(item => item.value !== '');

      this.formInitial();
      this.patchValue(this.existingdetails);


    }
    else {
      //  alert("else condition");
      this.ConfigurationForm = this.fb.group({
        mainkey: ['', Validators.compose([
          Validators.required,
          Validators.maxLength(4),
          Validators.pattern(VALIDATION_PATTERNS.SPACESTRICTFORINITIALVALIDATION)
        ])],
        Rows: this.fb.array([this.createSubKey()])
      });
    }
    const userdata = this.utilityservice.getLoggeduser();
    this.loginuserid = userdata.userid;


  }
  ngOnInit() {
    this.getProductList();
    this.setDescHeight();
    if (this.isEdit) {
      this.modifyform.get('dataType')?.valueChanges.subscribe(value => {
        const keyControl = this.modifyform.get('keyValue');

        if (value === '' || value === 'Text') {
          keyControl?.setValidators([
            Validators.required,
            Validators.maxLength(1000),
            Validators.pattern(VALIDATION_PATTERNS.SPACESTRICTFORINITIALVALIDATION)
          ]);
        } else {
          keyControl?.setValidators([
            Validators.required,
            Validators.pattern(VALIDATION_PATTERNS.SPACESTRICTFORINITIALVALIDATION)
          ]);
        }

        keyControl?.updateValueAndValidity();
      });
    }
  }
  patchValue(data) {
    console.log(data, "data");

    this.modifyform.patchValue({
      product: data.productid,
      keyValue: data.keyvalue,
      title: data.title,
      description: data.description,
      pmsShow: data.pmsshowflag,
      pmsEdit: data.pmseditflag,
      selfShow: data.selfshowflag,
      selfEdit: data.selfeditflag,
      dataType: data.entereddatatype

    })
  }

  get formArr(): FormArray {
    return this.ConfigurationForm.get("Rows") as FormArray;
  }

  addNewRow() {
    this.formArr.push(this.createSubKey());
  }

  deleteRow(index: number) {
    this.formArr.removeAt(index);
    if (index > -1 && this.configdetailsList.length > 1) { // only splice array when item is found
      this.configdetailsList.splice(index, 1); // 2nd parameter means remove one item only
    }
  }


  setDescHeight(): void {
    if (!this.description) {
      this.descheight = 2;
      return;
    }

    const lines = this.description.split(/\r\n|\r|\n/);
    const numberOfLines = lines.length;

    const estimatedWrapLines = Math.ceil(this.description.length / 180);

    const totalLines = numberOfLines + estimatedWrapLines;

    this.descheight = totalLines > 2 ? totalLines : 2;
  }




  createSubKey(): FormGroup {
    return this.fb.group({

      subKey: ['', Validators.compose([

        Validators.required,
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC),
        Validators.maxLength(2)

      ])],

      dataType: ['', Validators.required],
      title: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(300),
        Validators.pattern(VALIDATION_PATTERNS.SPACESTRICTFORINITIALVALIDATION)])],

      //title: ['', Validators.compose([Validators.required, Validators.maxLength(300)])],
      //keyValue: ['', Validators.required],
      keyValue: ['', Validators.compose([Validators.required,Validators.maxLength(1000),
      Validators.pattern(VALIDATION_PATTERNS.SPACESTRICTFORINITIALVALIDATION)
      ])],
      description: ['', Validators.compose([Validators.required, Validators.maxLength(1000),
      Validators.pattern(VALIDATION_PATTERNS.SPACESTRICTFORINITIALVALIDATION)
      ])],
      product: ['', Validators.required],
      pmsShow: ['Y', Validators.required],
      pmsEdit: ['Y', Validators.required],
      selfShow: ['Y', Validators.required],
      selfEdit: ['Y', Validators.required]
    });
  }
  formInitial() {
    this.modifyform = this.fb.group({
      mainkey: ['', Validators.compose([
        Validators.required,
        Validators.pattern(VALIDATION_PATTERNS.SPACESTRICTFORINITIALVALIDATION)
      ])],
      subKey: ['', Validators.compose([
        Validators.maxLength(2),
        Validators.required,
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC)])],
      dataType: ['', Validators.required],
      title: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(300),
        Validators.pattern(VALIDATION_PATTERNS.SPACESTRICTFORINITIALVALIDATION)])],

      keyValue: ['', Validators.compose([Validators.required,
        Validators.maxLength(1000),
      Validators.pattern(VALIDATION_PATTERNS.SPACESTRICTFORINITIALVALIDATION)
      ])],
      description: ['', Validators.compose([Validators.required, Validators.maxLength(1000),
      Validators.pattern(VALIDATION_PATTERNS.SPACESTRICTFORINITIALVALIDATION)
      ])],
      product: ['', Validators.required],
      pmsShow: ['Y', Validators.required],
      pmsEdit: ['Y', Validators.required],
      selfShow: ['Y', Validators.required],
      selfEdit: ['Y', Validators.required]
    })
  }

  addSubKey() {
    this.formArr.push(this.createSubKey());
  }

  removeSubKey(index: number) {
    if (this.formArr.length > 1) {
      this.formArr.removeAt(index);
    }
  }
  getProductList() {
    this.appconfigservice.getproductforlist().subscribe(res => {
      this.productlist = res;
      if (this.saveTitle != "Modify") {
        this.productlist.unshift({ productname: 'Select', productid: '' })

      }
      //this.productlist.unshift({ productname: 'Select', productid: '' })
    })
  }
  save() {
    console.log(this.ConfigurationForm.invalid);

    if (this.ConfigurationForm.invalid) {
      this.validateAllFormFields(this.ConfigurationForm);
    } else {
      let configdetailsList = [];
      this.formArr.controls.map((e: any) => {

        configdetailsList.push({
          keyvalue: e.controls.keyValue.value,
          subkey: e.controls.subKey.value,
          datatype: e.controls.dataType.value,
          productid: e.controls.product.value,
          pmsshowflag: e.controls.pmsShow.value,
          pmseditflag: e.controls.pmsEdit.value,
          selfshowflag: e.controls.selfShow.value,
          selfeditflag: e.controls.selfEdit.value,
          title: e.controls.title.value,
          description: e.controls.description.value,
        })
      });
    const rawValue = this.ConfigurationForm.get('mainkey').value;
    const mainKey = Number(String(rawValue).substring(0, 4));
      const payload = {
        mainkey: mainKey,

        configuration: configdetailsList,
        csrftoken: this.CSRFToken

      }



      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`
      }).then((value) => {
        if (value.isConfirmed) {
          //   let data = this.ConfigurationForm.value;
          //   data['csrftoken']=this.CSRFToken
          //   this.appconfigservice.addappconfigdata(payload).subscribe((data) => {
          //     Swal.fire("Saved!", "", "success").then(() => {
          //       this.ref.close();
          //     });
          //   }, error => {
          //     Swal.fire({
          //       icon: "error",
          //       title: "Oops...",
          //       text: error.error.error,
          //       footer: "error status is :" + ' ' + error.status
          //     });
          //   });
          // } 
          this.appconfigservice.addappconfigdata(payload).subscribe({
            next: (response: any) => {

              if (response?.response === 'keyExists') {
                Swal.fire("Sub Key already exists!", "", "error");
              } else {
                Swal.fire("Configuration Key added successfully!", "", "success").then(() => {
                  this.ref.close();
                });
              }
            },
            error: (error) => {
              if(error.error.response == 'html') {
                                Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                })
                                }       
                              else{
                              Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: error.error.error,
                                footer: "error status is :" + ' ' + error.status
                              });}
            }
          });
        }

        else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
          this.ref.close();
        }
      });


    }


  }
  modify() {
    const payload = {
      keyvalue: this.modifyform.value.keyValue,
      subkey: this.existingdetails.subkey,
      datatype: this.modifyform.value.dataType,
      productid: this.modifyform.value.product,
      pmsshowflag: this.modifyform.value.pmsShow,
      pmseditflag: this.modifyform.value.pmsEdit,
      selfshowflag: this.modifyform.value.selfShow,
      selfeditflag: this.modifyform.value.selfEdit,
      title: this.modifyform.value.title,
      description: this.modifyform.value.description,
      configid: this.existingdetails.configid,
      mainkey: this.existingdetails.mainkey,
      csrftoken: this.CSRFToken

    }
    console.log(payload, "payload");

    if (this.loginuserid == 0) {
      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`
      }).then((value) => {
        if (value.isConfirmed) {
          // let data = this.ConfigurationForm.value;
          // data['csrftoken']=this.CSRFToken
          this.appconfigservice.modifyappconfigdatasuperadmin(payload).subscribe((data) => {
            Swal.fire("Configuration Key modified successfully!", "", "success").then(() => {
              this.ref.close();
            });
          }, error => {
            if(error.error.response == 'html') {
                              Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                              })
                              }       
                            else{
                            Swal.fire({
                              icon: "error",
                              title: "Oops...",
                              text: error.error.error,
                              footer: "error status is :" + ' ' + error.status
                            });}
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
          this.ref.close();
        }
      });

    } else {
      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`
      }).then((value) => {
        if (value.isConfirmed) {
          this.appconfigservice.modifyappconfigdataadmin(payload).subscribe((data) => {
            Swal.fire("Configuration Key modified successfully!", "", "success").then(() => {
              this.ref.close();
            });
          }, error => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.error.error,
              footer: "error status is :" + ' ' + error.status
            });
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
          this.ref.close();
        }
      });
    }
  }
  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }

  getSelectedProductName(row: any): string {
    const selectedId = row.get('product')?.value;
    const product = this.productlist.find(p => p.productid === selectedId);
    return product ? product.productname : 'Select Product';
  }

  getSelectedProductNameModify(): string {
    const selectedId = this.modifyform?.get('product')?.value;
    if (!selectedId || !this.productlist?.length) {
      return 'Select Product';
    }
    const product = this.productlist.find(
      (p: any) => p.productid === selectedId
    );
    return product?.productname || 'Select Product';
  }

  onSubKeyInput(event: any) {
    let value = event.target.value;
    value = value.toString().slice(0, 2);
    event.target.value = value;
  }

  onMainKeyInput(event: any) {
    let value = event.target.value;
    value = value.toString().slice(0, 4);
    event.target.value = value;
  }

  isAnyRowTextType(): boolean {
  return this.formArr?.controls?.some(control =>
    control.get('dataType')?.value === '' ||
    control.get('dataType')?.value === 'Text'
  );
}

}
